/** Set to true to load catalogs from /assets/i18n (local fallback). Set to false to call the live API. */
export const USE_LOCAL_TRANSLATION_FALLBACK = false;

export const TRANSLATION_API_PATHS = {
  languages: "/language-translation/languages",
  userLanguage: "/user-management/language",
  /** Locale is passed via Accept-Language header, not the URL path. */
  translations: "/language-translation/translations",
} as const;

/** Bumped to v5 when switching from static JSON to live API - invalidates all v4 cache entries. */
export const TRANSLATION_CACHE_STORAGE_PREFIX = "translation_catalog_v5";

/** Bump when local i18n JSON content changes so browsers don't reuse old assets. */
export const LOCAL_I18N_ASSET_VERSION = "20260717-es";

export const TRANSLATION_LOADER_MESSAGES = {
  switchingLanguageKey: "ui.common.lang_trans.LOADER_TEXT",
  switchingLanguage: "Switching language...",
  failed: "Unable to load translations. Showing English.",
} as const;

export const TRANSLATION_TOAST_MESSAGES = {
  unavailableTitle: "Language unavailable",
  unavailableDetail: (requestedLanguage: string, appliedLanguage: string) =>
    `Translations are not available for ${requestedLanguage}. Showing ${appliedLanguage}.`,
  loadFailedTitle: "Translation error",
  loadFailedDetail: TRANSLATION_LOADER_MESSAGES.failed,
} as const;
